import { SideSheet, CountryOptionList, SearchBar } from '@desquared/wave-components-library';
import React, { useEffect, useState, useRef } from 'react';
import { CountryCodeSideSheetStore } from '../../store/sideSheet';
import { CountryCodeStore } from '@/store/countryCode';
import { getLocalizedCountries } from './countries';
import styles from './CountryCodeAside.module.css';
import { useTranslations } from 'use-intl';
import { useRouter } from 'next/router';
import { searchObjectsByField } from '@/utils/countriesTransform';
import { useIsRtl } from '@/contexts/DirectionContext.jsx';
import { NationalityLabelStore } from '@/store/nationalityLabel';

export default function CountryCodeAside({ setOpenCountryCodeSideSheet, hasCountryCodes = true }) {
  const [sideSheet, setSideSheet] = useState(true);
  const { locale } = useRouter();
  const [searchValue, setSearchValue] = useState('');
  const refOne = useRef(null);
  const t = useTranslations('common.asides.country_code');
  const isRtl = useIsRtl();

  const hideCodesVisually = items =>
    !hasCountryCodes ? items.map(item => ({ ...item, dialCode: '', code: '' })) : items;

  const [searchCountries, setSearchCountries] = useState(hideCodesVisually(getLocalizedCountries(locale)));

  const onClick = () => {
    setTimeout(() => {
      CountryCodeSideSheetStore.close();
      if (setOpenCountryCodeSideSheet) {
        setOpenCountryCodeSideSheet(false);
      }
    }, '300');
  };

  useEffect(() => {
    const CountryCodeSideSheetStore$ = CountryCodeSideSheetStore.subscribe(setSideSheet);
    document.addEventListener('click', handleClickOutside, true);
    return () => {
      CountryCodeSideSheetStore$.unsubscribe();
      document.removeEventListener('click', handleClickOutside, false);
    };
  }, []);

  const handleClickOutside = e => {
    if (refOne.current && !refOne.current.contains(e.target)) {
      CountryCodeSideSheetStore.close();
    }
  };

  const onSearchChange = value => {
    setSearchValue(value);
    const fullList = getLocalizedCountries(locale);
    const results = searchObjectsByField(fullList, 'name', value);
    const codeResults = searchObjectsByField(fullList, 'code', value);

    setSearchCountries(hideCodesVisually([...results, ...codeResults]));
  };

  const onItemClick = country => {
    const fullList = getLocalizedCountries(locale);
    const original = fullList.find(c => c.name === country.name) || country;

    if (hasCountryCodes) {
      CountryCodeStore.update([original.code]);
    } else {
      NationalityLabelStore.update(original.name);
    }

    CountryCodeSideSheetStore.close();
    if (setOpenCountryCodeSideSheet) {
      setOpenCountryCodeSideSheet(false);
    }
  };

  useEffect(() => {
    setSearchCountries(hideCodesVisually(getLocalizedCountries(locale)));
  }, [locale, hasCountryCodes]);

  if (!sideSheet) return null;

  return (
    <div ref={refOne}>
      <SideSheet
        header={t('header')}
        hasClose={true}
        onClose={onClick}
        classOption={styles.countryCodeAsideIndex}
        isRtl={isRtl}
      >
        <div className={styles.countryCodeAsideContainer}>
          <SearchBar
            isSmall={false}
            isRound={false}
            text={t('search_bar_placeholder')}
            hasContainer={false}
            setValue={onSearchChange}
            value={searchValue}
          />
          <CountryOptionList items={searchCountries} onChange={onItemClick} classOption={styles.scroll} />
        </div>
      </SideSheet>
    </div>
  );
}
